import { emptyValidator } from "../../validators";

export const validatorMap = {
  EMPTY_VALIDATION: [emptyValidator()],
};
